import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import A_UserAvatar from '@/components/A_Atoms/A_UserAvatar/A_UserAvatar';
import styles from './TunnelTooltip.module.css';

const TRUNCATE_LENGTH = 50;

export interface TunnelTooltipProps {
  user: string;
  text: string;
  avatarUrl?: string;
  imageUrl?: string;
  x: number;
  y: number;
  containerRef?: React.RefObject<HTMLDivElement | null>;
}

export default function TunnelTooltip({
  user,
  text,
  avatarUrl,
  imageUrl,
  x,
  y,
  containerRef,
}: TunnelTooltipProps) {
  const [position, setPosition] = useState({ left: x, top: y });

  useEffect(() => {
    if (!containerRef?.current) return setPosition({ left: x, top: y });
    const rect = containerRef.current.getBoundingClientRect();
    setPosition({ left: rect.left + x, top: rect.top + y });
  }, [containerRef, x, y]);

  const truncatedText =
    text.length > TRUNCATE_LENGTH
      ? `${text.slice(0, TRUNCATE_LENGTH)}...`
      : text;

  const tooltipNode = (
    <div
      className={cn(styles.tooltip, 'effect-glass')}
      style={
        containerRef
          ? {
              position: 'fixed',
              left: position.left,
              top: position.top,
              zIndex: 9999,
            }
          : { left: x, top: y }
      }
    >
      <div className={styles.user_info_wrapper}>
        <div className={styles.avatar_wrapper}>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt=''
              className={styles.stone_img}
              width={32}
              height={32}
            />
          ) : (
            <A_UserAvatar src={avatarUrl} width={32} height={32} />
          )}
        </div>
        <span className={cn(styles.author_name, 'text-p-2')}>{user}</span>
      </div>
      <div className={styles.content}>
        <p className={cn(styles.comment_text, 'text-caption')}>
          {truncatedText}
        </p>
      </div>
    </div>
  );

  if (containerRef && typeof document !== 'undefined') {
    return createPortal(tooltipNode, document.body);
  }
  return tooltipNode;
}
